export const playerProfiles = [
  {
    id: 0,
    title: "player",
    subtitle: "registration_athlete_subtitle",
    usageprice: "registration_athlete_usageprice",
    maindescription: "registration_athlete_maindescription",
    subdescription: "",

    imageUrl: "/assets/images/avatar/avatar_1.jpg",
  },
];

export const partnerProfiles = [
  {
    id: 2,
    title: "i_own_club_facility",
    subtitle: "sportfacility_registration_subtitle",
    usageprice: "sportfacility_registration_usageprice",
    maindescription: "sportfacility_registration_maindescription",
    subdescription: "sportfacility_registration_subdescription",
    imageUrl: "/assets/images/court.png",
    identifier: "facility",
  },
  {
    id: 1,
    title: "i_am_coach",
    subtitle: "coach_registration_subtitle",
    usageprice: "coach_registration_usageprice",
    maindescription: "coach_registration_maindescription",
    subdescription: "coach_registration_subdescription",
    imageUrl: "/assets/images/whistle.png",
    identifier: "coach",
  },
  {
    id: 3,
    title: "tournamentorganiser_registration",
    subtitle: "tournamentorganiser_registration_subtitle",
    usageprice: "tournamentorganiser_registration_usageprice",
    maindescription: "tournamentorganiser_registration_maindescription",
    subdescription: "tournamentorganiser_registration_subdescription",
    imageUrl: "/assets/images/medal_first.png",
    identifier: "organiser",
  },
  {
    id: 4,
    title: "association_registration",
    subtitle: "association_registration_subtitle",
    usageprice: "association_registration_usageprice",
    maindescription: "association_registration_description",
    subdescription: "association_registration_optional_federation",
    imageUrl: "/assets/images/medal_first.png",
    identifier: "association",
  },
];
